(function(){
  const isStarterKitLanding = window.location.pathname.includes('/pages/starter-kit-offer');
  if (isStarterKitLanding) return;

  async function getCart(){
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) return null;
    return res.json();
  }

    async function removeItemsByKey(keys){
        for (const key of keys) {
            const res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({
                id: key,
                quantity: 0
            })
            });

            if (!res.ok) {
            let msg = `Could not remove item key: ${key}`;
            try {
                const err = await res.json();
                if (err && err.description) msg = err.description;
            } catch(e){}
            console.error('[SK2] remove failed:', msg);
            }
        }
    }

  (async function(){
    const cart = await getCart();
    if (!cart || !Array.isArray(cart.items)) return;

    const keysToRemove = cart.items
      .filter(item => item.properties && item.properties._sk2_offer === 'starter-kit')
      .map(item => item.key);

    if (!keysToRemove.length) return;

    console.info('[SK2] Removing starter kit items:', keysToRemove);
    await removeItemsByKey(keysToRemove);
  })();
})();